/**
 * @module 易花花极速版iOS相关模块路由
 */
export default [
  {
    path: '/thh/mine/service',
    name: 'thh_mine_service',
    component: () => import('@/pages/app/thh-app/mine/service.vue'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/thh/protocol/register',
    name: 'thh_protocol_register',
    component: () => import('@/pages/app/thh-app/protocol/register.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/thh/protocol/private',
    name: 'thh_protocol_private',
    component: () => import('@/pages/app/thh-app/protocol/private.vue'),
    meta: {
      title: '用户隐私保护政策'
    }
  }
]
